import axios, { AxiosResponse } from 'axios';
import { FetchLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL, LOCAL_BASE_URL } from '../constants/apiEndpoints';
import { normalizeApiPage } from './pagination';

const LOUNGE_FETCH_RETRY_DELAYS_MS = [650, 1400, 2500];

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export function shouldRetryLoungeFetch(err: any): boolean {
  if (!axios.isAxiosError(err)) return false;
  const status = err.response?.status;
  const contentType = String(err.response?.headers?.['content-type'] || '');
  // Retry only for transient failures.
  return (
    status == null ||
    status >= 500 ||
    status === 429 ||
    (status === 403 && contentType.includes('text/html'))
  );
}
export const getAllLoungesApi = async ({
  sortType,
  LoungeId,
  currentPage,
  searchValue,
  shortByTime,
}: FetchLoungesType) => {
  const responseBody = (response: AxiosResponse) => response.data;

  let sorvalue = null;
  
  localStorage.setItem('pagename', 'Disneyland Talk');
  
  const token = localStorage.getItem('token');
  const page = normalizeApiPage(currentPage);

  let sortByTime =
    shortByTime == 'true'
      ? `?page=${page}&sortordefault=ww`
      : `?page=${page}`;

  const user_id = localStorage.getItem('user_id');
  // remove endpoint
  const apiEndpoint = GET_BASE_URL + `/api/v1/home`;

  const getRequest = async (url: string) => {
    let lastError: unknown;

    for (let attempt = 0; attempt <= LOUNGE_FETCH_RETRY_DELAYS_MS.length; attempt += 1) {
      try {
        return await axios
          .get<Lounge[]>(url, {
            headers: {
              Authorization: `bearer ${token}`,
            },
          })
          .then(responseBody);
      } catch (err) {
        lastError = err;
        if (!shouldRetryLoungeFetch(err) || attempt === LOUNGE_FETCH_RETRY_DELAYS_MS.length) {
          throw err;
        }
        await sleep(LOUNGE_FETCH_RETRY_DELAYS_MS[attempt]);
      }
    }

    throw lastError;
  };

  if (searchValue != null) {
    const { data } = await getRequest(
      `${apiEndpoint}/search/post/${searchValue}${sortByTime}&user_id=${user_id}`
    );
    return data;
  } else {
    const { data } = await getRequest(`${apiEndpoint}${sortByTime}&user_id=${user_id}`);

    return data;
  }
};
